import React from "react";

import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";

import { OfferHistoryPeriodTags } from "@features/offer/shared/event/offer-history/OfferHistoryPeriodTags";
import { EventOffer } from "@gp/offer";
import useDayAndTimeFromEventStartTime from "@hooks/useDayAndTimeFromEventStartTime";
import { getOfferHistoryScore } from "@utils/offer/offerHistoryScore";
import classnames from "classnames";
import { observer } from "mobx-react";

export default observer(function HistoryEventTimeAndScore(props: {
	event: EventOffer;
}) {
	const { t } = useTranslation();
	const homeTeamClass = classnames("event__middle__home", {});
	const awayTeamClass = classnames("event__middle__away", {});
	const { day, time } = useDayAndTimeFromEventStartTime(
		props.event.startTime
	);
	const score = getOfferHistoryScore(props.event?.result);
	const penaltiesTooltipId = `event-header-penalties-${props.event.id}`;

	return (
		<div className="event__middle">
			<div
				className="event__middle__score"
				data-tooltip-id={
					score.penalties ? penaltiesTooltipId : undefined
				}
				data-tooltip-position-strategy="fixed"
			>
				<span className={homeTeamClass}>
					{score.penalties && (
						<span className="event__middle__pen">
							({score.penalties.home})
						</span>
					)}
					{score.total.home}
				</span>
				<span className="event__middle__divider">-</span>
				<span className={awayTeamClass}>
					{score.total.away}
					{score.penalties && (
						<span className="event__middle__pen">
							({score.penalties.away})
						</span>
					)}
				</span>
			</div>
			{score.penalties && (
				<Tooltip
					id={penaltiesTooltipId}
					className="react-tooltip--primary"
				>
					{t("OFFER_HISTORY.PENALTIES")}
				</Tooltip>
			)}

			<div className="event__middle__time event__middle__time--live">
				{day} {time}
				<OfferHistoryPeriodTags
					eventId={props.event.id}
					isAfterExtraTime={score.overTime != null}
					isAfterPenalties={score.penalties != null}
					tagBlock="event__middle__tag"
					idPrefix="event-header"
					showFullText
				/>
			</div>
		</div>
	);
});
